<script setup lang="ts">
import { translate } from '@/shared/i18n';
import { ProjectSettings } from '@/shared/lib';
import { Btn, Icon } from '@/shared/ui';

defineEmits<{
  close: [];
}>();
</script>

<template>
  <aside
    class="fixed top-4 right-4 z-50 w-[calc(100%-2rem)] max-w-md rounded-2xl border border-[var(--theme-border-subtle)] bg-[var(--theme-surface-raised)] p-4 shadow-2xl shadow-black/40"
    aria-label="Предложение установить приложение"
  >
    <Btn
      icon-container
      round
      size="small"
      class="absolute! top-3 right-3"
      aria-label="Закрыть"
      @click="$emit('close')"
    >
      <Icon
        name="lucide:x"
        width="20"
        height="20"
      />
    </Btn>

    <div class="pr-8">
      <h2 class="text-base font-semibold text-[var(--theme-text-primary)]">
        {{ translate('pwa.bannerTitle', { name: ProjectSettings.project.name }) }}
      </h2>

      <p class="mt-1 text-sm leading-5 text-[var(--theme-text-secondary)]">
        {{ translate('pwa.bannerDescription') }}
      </p>

      <p class="mt-2 text-xs leading-4 text-[var(--theme-text-muted)]">
        {{ translate('pwa.bannerHint') }}
      </p>
    </div>

    <div class="mt-4">
      <slot />
    </div>
  </aside>
</template>
